var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoice-wrap"},[_c('div',{staticClass:"block invoice-form"},[_c('a-form',{attrs:{"form":_vm.form,"label-col":{ span: 6 },"wrapper-col":{ span: 16 }}},[_c('a-form-item',{attrs:{"label":"发票类型"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'iType',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate,
                },
              ],
              validateTrigger: 'blur',
            },
          ]),expression:"[\n            'iType',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate,\n                },\n              ],\n              validateTrigger: 'blur',\n            },\n          ]"}],attrs:{"placeholder":"请输入发票类型","readOnly":"","size":"large"}})],1),_c('a-form-item',{attrs:{"label":"发票抬头"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'invoiceTitle',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate,
                },
              ],
              validateTrigger: 'blur',
            },
          ]),expression:"[\n            'invoiceTitle',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate,\n                },\n              ],\n              validateTrigger: 'blur',\n            },\n          ]"}],attrs:{"placeholder":`请输入${_vm.type === 0 ? '姓名' : 'XXX公司'}`,"size":"large"}})],1),(_vm.type === 1)?_c('a-form-item',{attrs:{"label":"纳税人识别号"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'taxpayerIdentity',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate,
                },
              ],
              validateTrigger: 'blur',
            },
          ]),expression:"[\n            'taxpayerIdentity',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate,\n                },\n              ],\n              validateTrigger: 'blur',\n            },\n          ]"}],attrs:{"placeholder":"请输入纳税人识别号","size":"large"}})],1):_vm._e(),_c('a-form-item',{attrs:{"label":"开票项目"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'project',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate,
                },
              ],
              validateTrigger: 'blur',
            },
          ]),expression:"[\n            'project',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate,\n                },\n              ],\n              validateTrigger: 'blur',\n            },\n          ]"}],attrs:{"placeholder":"请输入开票项目","readOnly":"","size":"large"}})],1),_c('a-form-item',{attrs:{"label":"开票金额"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'price',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate,
                },
              ],
              validateTrigger: 'blur',
            },
          ]),expression:"[\n            'price',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate,\n                },\n              ],\n              validateTrigger: 'blur',\n            },\n          ]"}],attrs:{"placeholder":"请输入开票金额","readOnly":"","size":"large"}})],1),_c('a-form-item',{attrs:{"label":"邮箱地址"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'email',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate,
                },
              ],
              validateTrigger: 'blur',
            },
          ]),expression:"[\n            'email',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate,\n                },\n              ],\n              validateTrigger: 'blur',\n            },\n          ]"}],attrs:{"placeholder":"请输入邮箱地址","size":"large"}})],1),_c('a-form-item',{attrs:{"label":"手机号码"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'phone',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate,
                },
              ],
              validateTrigger: 'blur',
            },
          ]),expression:"[\n            'phone',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate,\n                },\n              ],\n              validateTrigger: 'blur',\n            },\n          ]"}],attrs:{"placeholder":"请输入手机号码","size":"large"}})],1),_c('a-form-item',{attrs:{"label":"发票备注"}},[_c('a-textarea',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'invoiceContent',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate,
                },
              ],
              validateTrigger: 'blur',
            },
          ]),expression:"[\n            'invoiceContent',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate,\n                },\n              ],\n              validateTrigger: 'blur',\n            },\n          ]"}],attrs:{"placeholder":"您输入的备注信息会打印在发票备注栏。","size":"large"}})],1),_c('a-form-item',{attrs:{"label":"","wrapper-col":{ span: 16, offset: 6 }}},[_c('a-button',{staticClass:"submit-btn",attrs:{"type":"primary","size":"large","loading":_vm.loading},on:{"click":_vm.formSubmit}},[_vm._v("确认")])],1)],1)],1),(_vm.invoiceBookTips)?_c('div',{staticClass:"block invoice-notice",domProps:{"innerHTML":_vm._s(_vm.invoiceBookTips)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }